import nodata from "./../assets/nodata2.png";

const LoadingData = () => {
  return (
    <div className="loadingg mb-5">
      <div className="loading-container">
        <h5 className="mt-3 mb-5">Sorry, No Data Available</h5>
        <div className="nodata">
          <img src={nodata} alt="nodata" />
        </div>
      </div>
    </div>
  );
};

export default LoadingData;
